import { toast } from "react-toastify";
import img from "./img/trash.svg";
import "./Styles/styles.css";

export const Card = ({
  listTransactions,
  transaction,
  setListTransactions,
}) => {
  const remove = (element) => {
    setListTransactions(listTransactions.filter((item) => item.id !== element));
    toast.info("Removido com sucesso!");
  };
  return (
    <>
      <li
        className={
          transaction.type === "entrada" ? "card-container" : "card-exit"
        }
      >
        <div className="card-description">
          <h1>{transaction.describe}</h1>
          <p>{transaction.type}</p>
        </div>
        <div className="card-value">
          <p>
            {Number(transaction.value).toLocaleString("pt-br", {
              style: "currency",
              currency: "BRL",
            })}
          </p>
          <figure onClick={() => remove(transaction.id)} className="card-fig">
            <img src={img} alt="trash-img" />
          </figure>
        </div>
      </li>
    </>
  );
};
